import {Component} from '@angular/core';

@Component({
  selector: 'tt-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: false,
})
export class DashboardComponent {

}
